/* eslint-disable react-hooks/rules-of-hooks */
/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-21 21:31:29
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-09-26 16:22:48
 * @FilePath: /roboneo-web/src/pages/--roboneo/index.page.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState } from 'react';
import Head from 'next/head';
import { defineNextPage } from '@/common/next';
import PartnerLogos from '@/components/overseaHome/ui/PartnerLogos';
import FeatureShowcase from '@/components/overseaHome/ui/FeatureShowcase';
import type { ActivityItem, OverseaFeatureItem } from '@/apiSdk/api.type';
import CapabilitiesOverview from '@/components/overseaHome/ui/CapabilitiesOverview';
import MainScreen from '@/components/overseaHome/ui/MainScreen';
import {
  MOBILE_BG_VIDEO_TS,
  PC_BG_VIDEO_WEBM,
} from '@/components/overseaHome/ui/MainScreen/media';
import { getOverseaHomeServerData } from '@/apiSdk/overseaHomeServerData';
import Pricing from '@/components/overseaHome/ui/Pricing';
import FeedbackOverview from '@/components/overseaHome/ui/FeedbackOverview';
import CaseList from '@/components/overseaHome/ui/CaseList';
import TopAlert from '@/components/overseaHome/ui/TopAlert';
import Header from '@/components/overseaHome/layout/header';
import StartCreationBanner from '@/components/overseaHome/ui/StartCreationBanner';
import NextScript from 'next/script';
import { Footer } from '@/components/overseaHome/layout';
import { isMobile } from '@/utils';
import {
  HREFLANG_ALTERNATES,
  OVERSEA_CANONICAL_URL,
  OVERSEA_HOME_DESCRIPTION,
  OVERSEA_HOME_KEYWORDS,
  OVERSEA_HOME_TITLE,
} from './seo';
import style from './index.module.scss';

export default defineNextPage<{
  title: string;
  menus: Record<'product' | 'blog', OverseaFeatureItem[]>;
  activityList: ActivityItem[];
  countryCode: string;
  userAgent: string;
}>({
  pageConfig: {
    projectId: '/--oversea',
    layoutId: 'OverseaLayout',
    /** 在页面级服务端 HTML 中输出唯一、完整的海外首页 SEO 信息。 */
    renderHead() {
      return (
        <Head>
          <title>{OVERSEA_HOME_TITLE}</title>
          <meta name="description" content={OVERSEA_HOME_DESCRIPTION} />
          <meta name="keywords" content={OVERSEA_HOME_KEYWORDS} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={OVERSEA_HOME_TITLE} />
          <meta property="og:description" content={OVERSEA_HOME_DESCRIPTION} />
          <meta property="og:url" content={OVERSEA_CANONICAL_URL} />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content={OVERSEA_HOME_TITLE} />
          <meta name="twitter:description" content={OVERSEA_HOME_DESCRIPTION} />
          {/* Canonical 与 hreflang 优化 SEO：多语言/地区正确索引 */}
          <link rel="canonical" href={OVERSEA_CANONICAL_URL} />
          {HREFLANG_ALTERNATES.map(({ hreflang, href }) => (
            <link
              key={hreflang}
              rel="alternate"
              hrefLang={hreflang}
              href={href}
            />
          ))}
        </Head>
      );
    },
  },
  /** 获取海外首页 SSR 数据，慢接口由缓存与短超时策略负责降级。 */
  async getInitialProps(context) {
    const cookie = context.req?.headers.cookie;
    // 从 server.ts 中挂载到 req 上的 countryCode
    const requestWithCountryCode = context.req as (typeof context.req & { countryCode?: string; }) | undefined;
    const countryCode = requestWithCountryCode?.countryCode || '';
    const requestOptions = { cookie, countryCode };

    console.log('[请求首页数据] 开始');
    const { activityData, menus } = await getOverseaHomeServerData(requestOptions);
    const productMenus = menus.list.filter((item) => item.category === 'Product')[0];
    const blogMenus = menus.list.filter((item) => item.category === 'Blog')[0];
    const productFilteredMenus = productMenus?.list ?? [];
    const blogFilteredMenus = blogMenus?.list ?? [];
    console.log('activityData', JSON.stringify(activityData));
    console.log('productMenus', JSON.stringify(productFilteredMenus));
    console.log('blogMenus', JSON.stringify(blogFilteredMenus));
    console.log('[请求首页数据] 结束');

    // 获取浏览器信息
    const userAgent = context.req?.headers['user-agent'] || '';
    return {
      title: '首页',
      menus: { product: productFilteredMenus, blog: blogFilteredMenus },
      activityList: activityData?.list ?? [],
      countryCode,
      userAgent,
    };
  },
  /** 渲染海外官网首页，并只预加载当前设备实际消费的首屏视频。 */
  component: ({
    title,
    menus,
    activityList,
    userAgent,
    countryCode,
  }) => {
    const [isJSMpegLoaded, setIsJSMpegLoaded] = useState(false);
    const isPhone = isMobile(userAgent);
    console.log('isPhone', isPhone);

    const onJSMpegLoad = () => {
      console.log('jsmpeg.min.js loaded');
      setIsJSMpegLoaded(true);
    };

    return (
      <div className={style.container}>
        <Head>
          {isPhone ? (
            <link
              rel="preload"
              as="fetch"
              type="video/mp2t"
              href={MOBILE_BG_VIDEO_TS}
              crossOrigin="anonymous"
              fetchPriority="low"
            />
          ) : (
            <link
              rel="preload"
              as="video"
              type="video/webm"
              href={PC_BG_VIDEO_WEBM}
              crossOrigin="anonymous"
              fetchPriority="low"
            />
          )}
        </Head>
        { isPhone && !isJSMpegLoaded && <NextScript src="https://titan-img.meitudata.com/xiuxiu/h5/city-travel/js/jsmpeg.min.js" onLoad={onJSMpegLoad} />}
        <Header showAlert={activityList.length > 0} menus={menus} />
        {/* 顶部alter横幅 */}
        {activityList.length > 0 && <TopAlert activityList={activityList} />}
        {/* 首屏 */}
        <MainScreen isJSMpegLoaded={isJSMpegLoaded} isPhone={isPhone} />
        {/* 合作伙伴 */}
        <PartnerLogos />
        {/* 功能展示 */}
        <FeatureShowcase isJSMpegLoaded={isJSMpegLoaded} />
        {/* 案例列表 */}
        <CaseList />
        {/* 能力概览 */}
        {menus?.product?.length > 0 && <CapabilitiesOverview productMenus={menus.product} />}
        {/* 价格 */}
        <Pricing />
        {/* 反馈概览 */}
        <FeedbackOverview />
        {/* 开始创作横幅 */}
        <StartCreationBanner />
        {/* 页尾 */}
        <Footer countryCode={countryCode} />
      </div>
    );
  },
});
